import React, { useState, useEffect, useCallback } from 'react';
import classnames from 'classnames';
import { Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NavItem from './NavItem';
import useStyles from './style';
import { INavListProps } from './types';
import { useFlags } from 'launchdarkly-react-client-sdk';

function NavList({ basePath, className, items }: INavListProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [activePath, setActivePath] = useState<string | null>(pathname || null);
  const allFlags = useFlags();

  useEffect(() => {
    items.forEach((item) => {
      // for example /sales + /barcodes
      const basePagePath = basePath + item.path;
      const indexPath = pathname.indexOf(basePagePath);
      if (indexPath > -1) {
        setActivePath(basePagePath);
      }
    });
  }, [basePath, items, pathname]);

  const removeByFlag = useCallback(
    (arr: Array<any>) => {
      const menuConfigCopy = JSON.parse(JSON.stringify(arr));
      const falseFlags = Object.entries(allFlags)
        .map(([key, value]) => {
          if (value === false) {
            return key;
          } else {
            return undefined;
          }
        })
        .filter(Boolean);
      falseFlags?.forEach((flag) => {
        menuConfigCopy?.forEach((row, rowIndex) => {
          if (row?.name?.toLowerCase()?.includes(flag?.toLocaleLowerCase())) {
            menuConfigCopy.splice(rowIndex, 1);
          } else {
            row?.options?.forEach((option, optIndex) => {
              if (option?.name?.toLowerCase()?.includes(flag?.toLowerCase()))
                menuConfigCopy?.[rowIndex]?.['options']?.splice(optIndex, 1);
            });
          }
        });
      });

      return menuConfigCopy;
    },
    [allFlags]
  );

  return (
    <ul className={classnames(classes.root, className)} data-testid="navigation-list">
      {removeByFlag(items).map(({ name, options, path }) => (
        <Route
          children={() => (
            <NavItem
              activePath={activePath}
              label={t(`label.${name}`)}
              name={name}
              options={options}
              path={basePath + path}
              onPathChange={setActivePath}
            />
          )}
          key={path}
          path={basePath + path}
        />
      ))}
    </ul>
  );
}

export default React.memo(NavList);
